import React from 'react';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { defineMessages, useIntl } from 'react-intl';

import { VideoContentBlockSchema } from './schema';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
});

const VideoContentSidebar = (props) => {
  const {
    data,
    block,
    blocksErrors,
    onChangeBlock,
    navRoot,
    contentType,
    onChangeField,
  } = props;
  const intl = useIntl();

  const schema = VideoContentBlockSchema({ intl, contentType });

  return (
    <BlockDataForm
      schema={schema}
      title={intl.formatMessage(messages.Video)}
      onChangeField={(id, value) => {
        if ((id === 'url' || id === 'file') && onChangeField) {
          onChangeField(id, value);
          return;
        }

        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
      navRoot={navRoot}
      contentType={contentType}
      errors={blocksErrors}
    />
  );
};

export default VideoContentSidebar;
